import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { call, cancel, delay, fork, put, race, select, take } from '@redux-saga/core/effects';
import ddt from '@wix/da-ddt';
import { createAction } from 'redux-actions';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { cancelFetchForStream, fetchFailure, markAsCancelled, markAsFetching } from './base/actions';
import { getStreamType } from './base/selectors';
import * as offsetActions from './withOffset/actions';
import * as cursorActions from './withCursor/actions';
import { StreamType } from './types';
import { FetchType } from './base/types';
const logger = ddt.createLogger('streamHelpers');
export function getActionsForStreamType(type) {
    switch(type){
        case StreamType.WITH_OFFSET:
            return offsetActions;
        case StreamType.WITH_CURSOR:
            return cursorActions;
        default:
            return {};
    }
}
export const createCallbackActionCreator = (actionType)=>createAction(actionType, (streamId)=>({
            streamId
        }));
/** @deprecated use takeStreamFetch */ export function* throttleFetchingTask(streamId, throttleMs) {
    yield delay(throttleMs);
    yield put(markAsFetching(streamId));
}
/** Listens for fetch actions for a stream. If further actions come for the
 * same stream while there is a fetch already in progress, it discards them.
 * Also allows for canceling of any streams it is handling via cancelFetchForStream */ export const takeStreamFetch = (patternOrChannel, handler, ...args)=>fork(function*() {
        const forks = {};
        while(true){
            const { fetchAction, cancelAction } = yield race({
                fetchAction: take(patternOrChannel),
                cancelAction: take(cancelFetchForStream)
            });
            if (cancelAction) {
                const streamId = cancelAction.payload.streamId;
                const task = forks[streamId];
                if (task) {
                    yield cancel(task);
                    yield put(markAsCancelled(streamId));
                }
            }
            if (fetchAction) {
                const streamId = fetchAction.payload.streamId;
                if (forks[streamId] && forks[streamId].isRunning()) {
                    logger.log('Discard action task already running');
                    continue;
                }
                forks[streamId] = yield fork(handler, ...args.concat(fetchAction));
            }
        }
    });
function getFetchSuccessActionForType(actions, fetchType) {
    switch(fetchType){
        case FetchType.All:
            return actions.fetchAllSuccess;
        case FetchType.Previous:
            return actions.fetchPreviousSuccess;
        case FetchType.Next:
        default:
            return actions.fetchSuccess;
    }
}
/** Helper to do the fetching stuff right. Use in combination with takeStreamFetch. */ export function* fetchStreamContents({ streamId, url, fetchType = FetchType.Next, params, getStreamData, onSuccess, onFailure, papiProject, fakeResponse }) {
    try {
        logger.log('Fetching stream', streamId, params);
        const result = yield call(requestPuppy, {
            method: 'get',
            url,
            params,
            enableCancellation: true
        }, fakeResponse, papiProject);
        if (!result || isApiError(result)) {
            logger.error('Error response', streamId, result);
            yield put(fetchFailure({
                streamId,
                fetchType,
                errorMsg: result ? result.error : 'Failed to fetch...'
            }));
            if (onFailure) {
                yield call(onFailure, result || {});
            }
            return;
        }
        const streamType = yield select(getStreamType, streamId);
        const actions = getActionsForStreamType(streamType);
        const fetchSuccess = getFetchSuccessActionForType(actions, fetchType);
        if (!fetchSuccess) {
            return;
        }
        logger.log('Successful fetch', streamId, result);
        yield put(fetchSuccess(_object_spread({
            streamId
        }, getStreamData(result))));
        if (onSuccess) {
            yield call(onSuccess, result);
        }
    } catch (e) {
        logger.error('Error caught while fetching', e);
        yield put(fetchFailure({
            streamId,
            fetchType,
            errorMsg: 'Failed to fetch...'
        }));
        if (onFailure) {
            yield call(onFailure);
        }
    }
}

//# sourceMappingURL=helpers.js.map